<template>
    <div v-if="hasRole('Administrator') || hasRole('Einkäufer') || hasRole('Erweiterter Einkäufer') || hasRole('Berater')" class="card" style="border-width: 0px" v-show="doneLoading">
        <div class="card-header px-0" style="background-color: #f4f5fa">
            <router-link :to="'/app/risikoanalyse'" href="#">{{editType}} {{ $t("cfbcreate.header") }} </router-link>
            <v-icon style="height: 12px" vertical-align="baseline" class="mb-1" name="chevron-right" /> {{ auction["title_" + $i18n.locale] }}
            <router-link v-if="hasRole('Administrator')||hasRole('Einkäufer')||hasRole('Berater')||hasRole('Erweiterter Einkäufer')" :to="'/app/campaign/view/'+auction.id" href="#"><b-icon icon="eye" class="ml-1" scale="1.3"></b-icon></router-link>
        </div>
        <div class="card-body px-0" style="background-color: #f4f5fa">
            <b-form @submit.prevent="onSubmit" v-show="doneLoading">
                <b-tabs>
                    <b-tab :title="$t(`cfbcreate.tab_masterdata`)" active>
                        <b-card-group columns>
                            <b-overlay :show="auction.basedata_checked" rounded="lg">
                                <b-card :title="$t(`cfbcreate.card_data`)" class="mb-3 shadow" footer-text-variant="muted" footer-bg-variant="white">
                                    <b-card-text>
                                        <b-form-group :label="$t(`cfbcreate.auction_title_de`)" label-for="auction-title-de">
                                            <b-form-input id="auction-title-de" type="text" v-model="auction.title_de" :state="!$v.auction.title_de.$error ? null : false" style="background-color: #fdfdfd"></b-form-input>
                                        </b-form-group>
                                        <b-form-group :label="$t(`cfbcreate.auction_title_en`)" label-for="auction-title-en">
                                            <b-form-input id="auction-title-en" type="text" v-model="auction.title_en" :state="!$v.auction.title_en.$error ? null : false" style="background-color: #fdfdfd"></b-form-input>
                                        </b-form-group>

                                        <b-form-group :label="$t(`cfbcreate.auction_usage_type`)" label-for="usage-type">
                                            <b-form-select text-field="usage_type" value-field="id" :options="usageTypes" v-model="auction.usage_type_id" ></b-form-select>
                                        </b-form-group>

                                        <b-form-group :label="$t(`cfbcreate.auction_organizer`)" label-for="auction-organizer">
                                            <b-form-select text-field="display_name" value-field="id" :options="organizers" v-model="selectedOrganizer" :state="!$v.selectedOrganizer.$error ? null : false" style="background-color: #fdfdfd"></b-form-select>
                                        </b-form-group>

                                        <b-form-group :label="$t(`cfbcreate.auction_start`)" label-for="auction-start">
                                            <b-row>
                                                <b-col>
                                                    <b-form-datepicker today-variant="info" v-model="auction.start_date_date" :locale="$i18n.locale" start-weekday="1" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" id="auction-start" :placeholder="$t(`common.nodateselected`)" :state="!$v.auction.start_date.$error ? null : false">
                                                    </b-form-datepicker>
                                                </b-col>
                                                <b-col>
                                                    <b-form-timepicker v-model="auction.start_date_time" :locale="$i18n.locale" :state="!$v.auction.start_date.$error ? null : false">
                                                    </b-form-timepicker>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>

                                        <b-form-group :label="$t(`cfbcreate.auction_end`)" label-for="auction-end">
                                            <b-row>
                                                <b-col>
                                                    <b-form-datepicker today-variant="info" v-model="auction.end_date_date" :locale="$i18n.locale" start-weekday="1" :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }" id="auction-end" :placeholder="$t(`common.nodateselected`)" :state="!$v.auction.end_date.$error ? null : false">
                                                    </b-form-datepicker>
                                                </b-col>
                                                <b-col>
                                                    <b-form-timepicker v-model="auction.end_date_time" :locale="$i18n.locale" :state="!$v.auction.end_date.$error ? null : false">
                                                    </b-form-timepicker>
                                                </b-col>
                                            </b-row>
                                        </b-form-group>
                                    </b-card-text>

                                    <template #footer>
                                        <b-form-checkbox v-model="auction.basedata_checked" name="check-button" switch>
                                            {{ $t('cfbcreate.basedata_checked') }}
                                        </b-form-checkbox>
                                    </template>
                                </b-card>

                                <template #overlay>
                                    <div class="text-center">
                                        <b-icon icon="check-square" font-scale="2"></b-icon>
                                        <b-form-checkbox v-model="auction.basedata_checked" name="switch" switch>
                                            {{ $t('cfbcreate.basedata_checked') }}
                                        </b-form-checkbox>
                                    </div>
                                </template>
                            </b-overlay>  
    
                            <b-overlay :show="auction.conditions_checked" rounded="lg">
                                <b-card :title="this.isAuction ? this.$t(`cfbcreate.card_conditions`) : this.$t(`cfbcreate.card_pq_conditions`)" :sub-title="$t(`cfbcreate.card_conditions_subtitle`)" class="mb-3 shadow" footer-text-variant="muted" footer-bg-variant="white">
                                    <b-card-text>
                                        <b-form-group :label="$t(`cfbcreate.auction_contact`)" class="d-flex justify-content-between mb-0" label-for="auction-contact">
                                            <b-button v-b-toggle.help_contact pill size="sm" variant="outline-secondary" style="font-family: times; height: 1.3rem; width: 1.3rem" class="d-flex pl-2 p-0 ml-auto"><em>i</em></b-button>
                                        </b-form-group>
                                        <b-form-textarea v-model="auction.contact" id="auction-contact" class="mb-3" :no-resize="true" :rows="3" :max-rows="3" :state="!$v.auction.contact.$error ? null : false" style="background-color: #fdfdfd"></b-form-textarea>
                                        <b-sidebar right id="help_contact" :title="$t(`cfbcreate.auction_contact`)" backdrop-variant="dark" backdrop shadow width="600px" max-width="100%">
                                            <div class="px-3 py-2">
                                                <b-list-group>
                                                    <b-list-group-item button class="d-flex align-items-center">{{ $t("help.contact_1") }}<b-icon class="ml-auto" icon="clipboard" @click="copyText($t(`help.contact_1`))"></b-icon></b-list-group-item>
                                                    <b-list-group-item button class="d-flex align-items-center">{{ $t("help.contact_2") }}<b-icon class="ml-auto" icon="clipboard" @click="copyText($t(`help.contact_2`))"></b-icon></b-list-group-item>
                                                    <b-list-group-item button class="d-flex align-items-center">{{ $t("help.contact_3") }}<b-icon class="ml-auto" icon="clipboard" @click="copyText($t(`help.contact_3`))"></b-icon></b-list-group-item>
                                                </b-list-group>
                                            </div>
                                        </b-sidebar>

                                        <b-form-group :label="$t(`cfbcreate.auction_techcontact`)" class="d-flex justify-content-between mb-0" label-for="auction-technical-contact">
                                            <b-button v-b-toggle.help_technicalcontact pill size="sm" variant="outline-secondary" style="font-family: times; height: 1.3rem; width: 1.3rem" class="d-flex pl-2 p-0 ml-auto"><em>i</em></b-button>
                                        </b-form-group>
                                        <b-form-textarea v-model="auction.technical_contact" id="auction-technical-contact" class="mb-3" :no-resize="true" :rows="3" :max-rows="3" style="background-color: #fdfdfd"></b-form-textarea>
                                        <b-sidebar right id="help_technicalcontact" :title="$t(`cfbcreate.auction_techcontact`)" backdrop-variant="dark" backdrop shadow width="600px" max-width="100%">
                                            <div class="px-3 py-2">
                                                <b-list-group>
                                                    <b-list-group-item button class="d-flex align-items-center">{{ $t("help.technicalcontact_1") }}<b-icon class="ml-auto" icon="clipboard" @click="copyText($t(`help.technicalcontact_1`))"></b-icon></b-list-group-item>
                                                    <b-list-group-item button class="d-flex align-items-center">{{ $t("help.technicalcontact_2") }}<b-icon class="ml-auto" icon="clipboard" @click="copyText($t(`help.technicalcontact_2`))"></b-icon></b-list-group-item>
                                                    <b-list-group-item button class="d-flex align-items-center">{{ $t("help.technicalcontact_3") }}<b-icon class="ml-auto" icon="clipboard" @click="copyText($t(`help.technicalcontact_3`))"></b-icon></b-list-group-item>                                                
                                                </b-list-group>
                                            </div>
                                        </b-sidebar>

                                        <b-form-group :label="$t(`cfbcreate.auction_conditions`)" label-for="auction-conditions">
                                            <b-form-textarea v-model="auction.conditions" id="auction-conditions" :no-resize="false" :rows="5" style="background-color: #fdfdfd"></b-form-textarea>
                                        </b-form-group>
                                    </b-card-text>
                                    <template #footer>
                                        <b-form-checkbox v-model="auction.conditions_checked" name="check-button" switch>
                                            {{ $t('cfbcreate.conditions_checked') }}
                                        </b-form-checkbox>
                                    </template>   
                                </b-card>
                                <template #overlay>
                                    <div class="text-center">
                                        <b-icon icon="check-square" font-scale="2"></b-icon>
                                        <b-form-checkbox v-model="auction.conditions_checked" name="switch" switch>
                                            {{ $t('cfbcreate.conditions_checked') }}
                                        </b-form-checkbox>
                                    </div>
                                </template>
                            </b-overlay>
                            
                            <b-card :title="$t(`cfbcreate.card_assigning`)" :sub-title="$t(`cfbcreate.card_intern_subtitle_assigning`)" class="mb-3" style="background-color: #f4f5fa">
                                <b-card-text>
                                    <b-form-group :label="$t(`cfbcreate.auction_status`)" label-for="auction-status">
                                        <b-form-select v-model="auction.status" class="mb-3" style="background-color: #fdfdfd">
                                        <option value="0">{{ $t("cfbcreate.status_0") }}</option>
                                        <option value="1">{{ $t("cfbcreate.status_1") }}</option>
                                        <option value="2">{{ $t("cfbcreate.status_2") }}</option>
                                        <option value="3">{{ $t("cfbcreate.status_3") }}</option>
                                        </b-form-select>
                                    </b-form-group>

                                    <b-form-group label="" label-for="auction-uploads">
                                        <b-form-checkbox id="auction-uploads" v-model="auction.uploads_active" inline> {{ $t("cfbcreate.auction_uploads") }}</b-form-checkbox>
                                    </b-form-group>
                                    
                                    <b-button class="button-margin mb-4" variant="outline-primary" type="submit"><b-icon icon="save" />{{ $t("cfbcreate.btn_save") }}</b-button>
                                    
                                    <b-form-group :label="$t(`cfbcreate.auction_processstatus`)" label-for="auction-process-status">
                                        <b-form-select v-model="auction.process_status" class="mb-3" style="background-color: #fdfdfd">
                                        <option value="0">{{ $t("campaign_view.processstatus_0") }}</option>
                                        <option value="1">{{editType}} {{ $t("campaign_view.processstatus_1") }}</option>
                                        <option value="2">{{editType}} {{ $t("campaign_view.processstatus_2") }}</option>
                                        <option value="3">{{editType}} {{ $t("campaign_view.processstatus_3") }}</option>
                                        <option value="4">{{ $t("campaign_view.processstatus_4") }}</option>
                                        <option value="5">{{ $t("campaign_view.processstatus_5") }}</option>
                                        <option value="6">{{ $t("campaign_view.processstatus_6") }}</option>
                                        <option value="7">{{ $t("campaign_view.processstatus_7") }}</option>
                                        <option value="8">{{ $t("campaign_view.processstatus_8") }}</option>
                                        </b-form-select>
                                    </b-form-group>


                                    <b-form-group :label="$t(`cfbcreate.auction_samplingstatus`)" label-for="auction-sampling-status">
                                            <b-form-select v-model="auction.sampling_status" class="mb-3" style="background-color: #fdfdfd">
                                            <option value="0">{{ $t("campaign_view.samplingstatus_0") }}</option>
                                            <option value="1">{{ $t("campaign_view.samplingstatus_1") }}</option>
                                            <option value="2">{{ $t("campaign_view.samplingstatus_2") }}</option>
                                            <option value="3">{{ $t("campaign_view.samplingstatus_3") }}</option>
                                            <option value="4">{{ $t("campaign_view.samplingstatus_4") }}</option>
                                            </b-form-select>
                                    </b-form-group>

                                    <b-form-group :label="$t(`cfbcreate.auction_notes`)" label-for="auction-notes">
                                        <b-form-textarea v-model="auction.notes" id="auction-notes" :no-resize="false" :rows="8" :max-rows="20" style="background-color: #fdfdfd"></b-form-textarea>
                                    </b-form-group>
                                </b-card-text>
                            </b-card>

                        </b-card-group>
                    </b-tab>

                    <b-tab v-if="isAuction" class="mb-4" :title="$t(`cfbcreate.tab_items`)" :disabled="!editMode">
                        <b-overlay :show="auction.items_checked" rounded="lg">
                            <b-card :title="$t(`cfbcreate.card_items`)" class="mb-3 shadow" footer-text-variant="muted" footer-bg-variant="white">
                                <b-button class="button-margin" variant="primary" @click="showNewItemForm"><b-icon icon="bag-plus" />{{ $t("cfbcreate.btn_newitem") }}</b-button>
                                <b-button class="button-margin" variant="outline-primary" @click.prevent="showImport" v-if="hasRole('Administrator')||hasRole('Berater')||hasRole('Erweiterter Einkäufer')">
                                    <b-iconstack>
                                        <b-icon stacked icon="bag"></b-icon>
                                        <b-icon stacked icon="arrow-down" shift-h="" shift-v="-2" scale="0.5"></b-icon>
                                    </b-iconstack>
                                    {{ $t("cfbcreate.btn_itemimport") }}
                                </b-button>
                                <div class="table-scrollable">
                                    <b-table striped hover :items="auction.items" :fields="itemTableFields" sort-by="order">
                                        <template #cell(actions)="data">
                                            <b-link class="m-1" href="#" v-show="data.index > 0" @click="moveItemUp(data.item.order)"><b-icon icon="chevron-up" scale="1.2"></b-icon></b-link>
                                            <b-link class="m-1" href="#" v-show="data.index < auction.items.length-1" @click="moveItemDown(data.item.order)"><b-icon icon="chevron-down" scale="1.2"></b-icon></b-link>
                                            <b-link class="m-1" href="#" @click.prevent="editAuctionItem(data.item)"><b-icon icon="pencil-square" scale="1.2"></b-icon></b-link>
                                            <b-link class="m-1" href="#" @click.prevent="requestDeleteAuctionItem(data.item)"><b-icon icon="trash" scale="1.2"></b-icon></b-link>
                                        </template>
                                        <template #cell(actual_value)="data">
                                            {{toCurrency(data.item.actual_value, auction.precision)}}
                                        </template>
                                        <template #cell(price_alert_value_buyer)="data">
                                            {{toCurrency(data.item.price_alert_value_buyer, auction.precision)}}
                                        </template>
                                        <template #cell(price_alert_value_supplier)="data">
                                            {{toCurrency(data.item.price_alert_value_supplier, auction.precision)}}
                                        </template>
                                        <template #cell(lowest_bid)="data">
                                            {{toCurrency(data.item.lowest_bid, auction.precision)}}
                                        </template>
                                    </b-table>
                                </div>
                                <template #footer>
                                    <b-form-checkbox v-model="auction.items_checked" name="check-button" switch>
                                        Positionen vollständig und korrekt beschrieben...
                                    </b-form-checkbox>
                                </template>
                            </b-card>

                            <template #overlay>
                                <div class="text-center">
                                    <b-icon icon="check-square" font-scale="2"></b-icon>
                                    <b-form-checkbox v-model="auction.items_checked" name="switch" switch>
                                        Positionen vollständig und korrekt beschrieben...
                                    </b-form-checkbox>
                                </div>
                            </template>
                        </b-overlay>
                    </b-tab>

                    <b-tab :title="$t(`cfbcreate.tab_questionnaire`)" :disabled="!editMode">
                        <b-overlay :show="auction.questionnaires_checked" rounded="lg">
                            <b-card :title="$t(`cfbcreate.card_questionnaire`)" class="mb-3 shadow" footer-text-variant="muted" footer-bg-variant="white">
                                <b-card-text>
                                    <template v-if="relatedQuestionnaires.length > 0">
                                        <template v-for="questionnaire in relatedQuestionnaires">
                                            <b-row class="mb-2 ml-1" v-bind:key="questionnaire.id">
                                                <b-form-checkbox v-model="questionnaire.related">
                                                    {{ questionnaire.year.year }} - {{ questionnaire['name_' + $i18n.locale] }} 
                                                </b-form-checkbox>
                                            </b-row>
                                        </template>
                                    </template>
                                    <template v-else>
                                        <b-row class="mt-4 ml-1">
                                            <p>Keine Fragebögen für diese Aktion mit der Zuordnung '{{ auction.usage_type }}' verfügbar</p>
                                        </b-row>
                                        <b-row class="mb-2 ml-1">
                                            <p>Einzelnen Fragebögen muss die Zuordnung '{{ auction.usage_type }}' zugewiesen werden, damit diese Fragebögen hier zur Auswahl stehen können.</p>
                                        </b-row>
                                    </template>
                                </b-card-text>
                                <br />
                                <b-button class="button-margin" variant="outline-primary" to="/app/questionnaires"><b-icon icon="pencil-square" />{{ $t("cfbcreate.btn_editquestionnaire") }}</b-button>
                                
                                <template #footer>
                                    <b-form-checkbox v-model="auction.questionnaires_checked" name="check-button" switch>
                                        {{ $t('cfbcreate.questionnaires_checked') }}
                                    </b-form-checkbox>
                                </template>

                            </b-card>
                         
                            <template #overlay>
                                <div class="text-center">
                                    <b-icon icon="check-square" font-scale="2"></b-icon>
                                    <b-form-checkbox v-model="auction.questionnaires_checked" name="switch" switch>
                                        {{ $t('cfbcreate.questionnaires_checked') }}
                                    </b-form-checkbox>
                                </div>
                            </template>
                        </b-overlay>
                    </b-tab>

                    <b-tab :title="this.isAuction ? this.$t(`cfbcreate.tab_tenderdocuments`) : this.$t(`cfbcreate.tab_documents`)" :disabled="!editMode">
                        <b-overlay :show="auction.documents_checked" rounded="lg">
                            <b-card :title="this.isAuction ? this.$t(`cfbcreate.card_documents`) : this.$t(`cfbcreate.card_pq_documents`)" class="mb-3 shadow" footer-text-variant="muted" footer-bg-variant="white">
                                <b-button class="button-margin" variant="primary" @click="showFileForm"><b-icon icon="file-earmark-plus" />{{ $t("cfbcreate.btn_newfile") }}</b-button>
                                <div class="table-scrollable">
                                    <b-table striped hover :items="auction.files" :fields="fileTableFields" sort-by="order">
                                        <template #cell(actions)="data">
                                            <b-link class="m-1" href="#" v-show="data.index > 0" @click="moveFileUp(data.item.id)"><b-icon icon="chevron-up" scale="1.2"></b-icon></b-link>
                                            <b-link class="m-1" href="#" v-show="data.index < auction.files.length-1" @click="moveFileDown(data.item.id)"><b-icon icon="chevron-down" scale="1.2"></b-icon></b-link>
                                            <b-link class="m-1" href="#" @click="deleteFile(data.item)"><b-icon icon="trash" scale="1.2"></b-icon></b-link>
                                            <b-link class="m-1" href="#" @click="downloadFile(data.item)"><b-icon icon="download" scale="1.2"></b-icon></b-link>
                                            <b-link class="m-1" href="#" @click="editFile(data.item)"><b-icon icon="pencil-square" scale="1.2"></b-icon></b-link>
                                        </template>
                                    </b-table>
                                </div>
                                <template #footer>
                                    <b-form-checkbox v-model="auction.documents_checked" name="check-button" switch>
                                        {{ $t('cfbcreate.documents_checked') }}
                                    </b-form-checkbox>
                                </template>
                            </b-card>
                            
                            <template #overlay>
                                <div class="text-center">
                                    <b-icon icon="check-square" font-scale="2"></b-icon>
                                    <b-form-checkbox v-model="auction.documents_checked" name="switch" switch>
                                        {{ $t('cfbcreate.documents_checked') }}
                                    </b-form-checkbox>
                                </div>
                            </template>
                        </b-overlay>
                    </b-tab>

                    <b-tab :title="this.isAuction ? this.$t(`cfbcreate.tab_regulations`) : this.$t(`cfbcreate.tab_esg_regulations`)" :disabled="!editMode">
                        <b-overlay :show="auction.qualification_requirements_checked" rounded="lg">
                            <!-- Qualitätsanforderungen-->
                            <b-card :title="$t(`cfbcreate.card_qualification_requirements`)" class="mb-3 shadow" footer-text-variant="muted" footer-bg-variant="white">
                                <b-card-text>
                                    <!-- Lieferkettensorgfaltspflichtengesetz (LkSG)-->
                                    <b-form-group :label="$t(`cfbcreate.supply_chain_de`)" class="d-flex justify-content-between mb-0"  label-for="auction-supply-chain-de">
                                        <b-button v-b-toggle.supply_chain_help pill size="sm" variant="outline-secondary" style="font-family: times; height: 1.3rem; width: 1.3rem" class="d-flex pl-2 p-0 ml-auto"><em>i</em></b-button>
                                    </b-form-group>
                                    <b-form-textarea v-model="auction.supply_chain_de" id="auction-supply-chain-de" class="overflow-auto mb-3" :no-resize="false" :rows="15" style="background-color: #fdfdfd"></b-form-textarea>
                                    <b-form-group :label="$t(`cfbcreate.supply_chain_en`)" class="d-flex justify-content-between mb-0"  label-for="auction-supply-chain-en">
                                        <b-button v-b-toggle.supply_chain_help pill size="sm" variant="outline-secondary" style="font-family: times; height: 1.3rem; width: 1.3rem" class="d-flex pl-2 p-0 ml-auto"><em>i</em></b-button>
                                    </b-form-group>
                                    <b-form-textarea v-model="auction.supply_chain_en" id="auction-supply-chain-en" class="overflow-auto mb-3" :no-resize="false" :rows="15" style="background-color: #fdfdfd"></b-form-textarea>
                                    <b-sidebar right id="supply_chain_help" :title="$t(`help.assistance`)" backdrop-variant="dark" backdrop shadow width="600px" max-width="100%">
                                        <div class="px-3 py-2">
                                            <b-list-group>
                                                <b-list-group-item button class="d-flex align-items-center">{{ $t("help.supply_chain_1") }}<b-icon class="ml-auto" icon="clipboard" @click="copyText($t(`help.supply_chain_1`))"></b-icon></b-list-group-item>
                                                <b-list-group-item button class="d-flex align-items-center">{{ $t("help.supply_chain_2") }}<b-icon class="ml-auto" icon="clipboard" @click="copyText($t(`help.supply_chain_2`))"></b-icon></b-list-group-item>
                                                <b-list-group-item button class="d-flex align-items-center">{{ $t("help.supply_chain_3") }}<b-icon class="ml-auto" icon="clipboard" @click="copyText($t(`help.supply_chain_3`))"></b-icon></b-list-group-item>
                                                <b-list-group-item button class="d-flex align-items-center">{{ $t("help.supply_chain_4") }}<b-icon class="ml-auto" icon="clipboard" @click="copyText($t(`help.supply_chain_4`))"></b-icon></b-list-group-item>
                                            </b-list-group>
                                        </div>
                                    </b-sidebar>
                                    <br />
                                    <b-button class="button-margin" type="submit" variant="primary"><b-icon icon="save" />{{ $t("cfbcreate.btn_save") }}</b-button>
                                </b-card-text>
                                <template #footer>
                                    <b-form-checkbox v-model="auction.qualification_requirements_checked" name="check-button" switch>
                                        {{ $t('cfbcreate.instructions_checked') }}
                                    </b-form-checkbox>
                                </template>
                            </b-card>
                            <template #overlay>
                                <div class="text-center">
                                    <b-icon icon="check-square" font-scale="2"></b-icon>
                                    <b-form-checkbox v-model="auction.qualification_requirements_checked" name="switch" switch>
                                        {{ $t('cfbcreate.instructions_checked') }}
                                    </b-form-checkbox>
                                </div>
                            </template>
                        </b-overlay>

                    </b-tab>

                    <b-tab :title="this.isAuction ? this.$t(`cfbcreate.tab_user`) : this.$t(`cfbcreate.tab_pq_user`)" :disabled="!editMode">
                        <b-overlay :show="auction.userlist_checked" rounded="lg">
                            <b-card :title="$t(`cfbcreate.card_user`)" class="mb-3 shadow" footer-text-variant="muted" footer-bg-variant="white">
                                <div class="table-scrollable">
                                    <b-table striped hover :items="users" :fields="userTableFields">
                                        <template #cell(accepted_terms_of_service)="data">
                                            <b-form-checkbox v-model="data.item.accepted_terms_of_service" disabled />
                                        </template>
                                        <template #cell(proof_of_entrepreneurial_status)="data">
                                            <b-form-checkbox v-model="data.item.proof_of_entrepreneurial_status" disabled />
                                        </template>
                                        <template #cell(actions)="data">
                                            <b-link class="m-1" href="#" @click="unassignUser(data.item)"><b-icon icon="trash" scale="1.2"></b-icon></b-link>
                                        </template>
                                    </b-table>
                                </div>

                                <div v-if="hasRole('Administrator')||hasRole('Berater')||hasRole('Erweiterter Einkäufer')">
                                    <vue-bootstrap-typeahead
                                        :data="availableUsers"
                                        :placeholder="$t(`cfbcreate.placeholder_searchuser`)"
                                        v-model="userSearch"
                                        :serializer="d => d.name + ' - ' + d.company + ' - ' + d.product_group"
                                        @hit="selectedUser = $event" />

                                    <br />
                                    <b-button class="button-margin" variant="primary" @click="addUserToAuction"><b-icon icon="person-plus" />{{ $t("cfbcreate.btn_adduser") }}</b-button>
                                    <p>{{ $t("cfbcreate.adduser_notes") }}</p>
                                </div>

                                <template #footer>
                                    <b-form-checkbox v-model="auction.userlist_checked" name="check-button" switch>
                                        {{ $t('cfbcreate.userlist_checked') }}
                                    </b-form-checkbox>
                                </template>
                            </b-card>

                            <template #overlay>
                                <div class="text-center">
                                    <b-icon icon="check-square" font-scale="2"></b-icon>
                                    <b-form-checkbox v-model="auction.userlist_checked" name="switch" switch>
                                        {{ $t('cfbcreate.userlist_checked') }}
                                    </b-form-checkbox>
                                </div>
                            </template>
                        </b-overlay>
                    </b-tab>

                    <b-tab :title="this.$t(`cfbcreate.tab_invitations`)" :disabled="!editMode">
                        <b-card :title="$t(`cfbcreate.card_invitations`)" class="mb-3 shadow" footer-text-variant="muted" footer-bg-variant="white">
                                <b-card-text>
                                    <p>{{ $t("cfbcreate.invitation_note1") }}</p>
                                    <p>{{ $t("cfbcreate.invitation_note2") }}</p>
                                    <b-button class="button-margin" variant="primary" to="/app/invitation/new"><b-icon icon="envelope-open" />{{ $t("invitation.btn_invitation_new") }}</b-button>
                                    <b-button class="button-margin" variant="outline-primary" to="/app/invitations"><b-icon icon="envelope" />{{ $t("cfbcreate.btn_invitations") }}</b-button>
                                </b-card-text>
                            </b-card>
                    </b-tab>

                    <b-tab :title="$t(`cfbcreate.tab_notes`)" :disabled="!editMode">
                        <b-card :title="$t(`cfbcreate.card_notes`)" class="mb-3 shadow">
                            <b-card-text>
                                <b-form-group :label="$t(`cfbcreate.auction_notes`)" label-for="auction-notes">
                                    <b-form-textarea v-model="auction.notes" id="auction-notes" :no-resize="false" :rows="7" style="background-color: #fdfdfd"></b-form-textarea>
                                </b-form-group>
                            </b-card-text>
                            <br />
                        </b-card>
                        <b-card v-if="isAuction" :title="$t(`cfbcreate.negotiation_notes`)" class="mb-3 shadow">
                            <b-card-text>
                                <b-form-group :label="$t(`cfbcreate.negotiation_notes`)" label-for="negotiation-notes">
                                    <b-form-textarea v-model="auction.negotiation_note" id="negotiation-notes" :no-resize="false" :rows="7" style="background-color: #fdfdfd"></b-form-textarea>
                                </b-form-group>
                            </b-card-text>
                            <br />
                        </b-card>
                        <b-card :title="$t(`cfbcreate.award_notes`)" class="mb-3 shadow">
                            <b-card-text>
                                <b-form-group :label="$t(`cfbcreate.award_notes`)" label-for="award-notes">
                                    <b-form-textarea v-model="auction.award_note" id="award-notes" :no-resize="false" :rows="7" style="background-color: #fdfdfd"></b-form-textarea>
                                </b-form-group>
                            </b-card-text>
                            <br />
                        </b-card>
                    </b-tab>
                    
                </b-tabs>
                <br />
                <b-button class="button-margin" type="submit" variant="primary"><b-icon icon="save" />{{ $t("cfbcreate.btn_save") }}</b-button>
            </b-form>
        </div>

        <AuctionItemModal ref="auctionItemModal" :savedCallback="reloadAuctionItemList" :auction="auction"/>

        <FileUploadModal ref="fileUploadModal" :savedCallback="reloadFiles" :auction="auction"/>

        <b-modal ref="importModal" hide-footer :title="$t(`cfbcreate.modal_itemimport`)">
            <div class="d-block text-center">
                {{ $t("cfbcreate.modal_notes") }}
            </div>
            <b-form-file ref="excelFileInput" v-model="excelFile" :state="!$v.excelFile.$error ? null : false"  :placeholder="$t(`cfbcreate.modal_placeholder`)"></b-form-file>
            <b-button class="button-margin mt-3" variant="primary" block @click="importExcelFile">{{ $t("cfbcreate.btn_import") }}</b-button>

            <hr class="mt-3">
            <div>
                <div class="d-block mt-4 h3">{{$t(`cfbcreate.import_help_title`)}}</div>
                <div class="d-block mt-2">{{$t(`cfbcreate.import_help_text`)}}</div>
                <b-button class="button-margin mt-3" variant="outline-primary" @click="downloadTemplate">{{$t(`cfbcreate.import_template`)}}</b-button>
            </div>
        </b-modal>
        <b-modal ref="confirmationModal" hide-footer :title="$t(`cfbcreate.modal_delete_title`)">
            <div class="d-block text-center">
                <p >{{ $t("cfbcreate.confirmation_text_1") }} <strong>'{{auctionItemToDelete.name}}'</strong> {{ $t("cfbcreate.confirmation_text_2") }}</p>
            </div>
            <b-button class="button-margin mt-3" variant="outline-danger" block @click="deleteAuctionItem">{{ $t("cfbcreate.btn_delete") }}</b-button>
        </b-modal>
        <b-modal ref="importErrorModal" :title="$t(`cfbcreate.import_error_title`)" v-b-modal.modal-center ok-only header-bg-variant="warning" footer-bg-variant="warning">
            <p >{{ $t("cfbcreate.import_error_text") }} {{ errorMessage }}</p>
        </b-modal>
    </div>
</template>
<script>
import {_} from 'vue-underscore';
import AuctionItemModal from './modules/CreatePositionModal';
import FileUploadModal from './modules/FileUploadModal';

import callForBidsService from '../../../../services/CallForBidsService';
import questionnaireService from '../../../../services/QuestionnaireService';
import importService from '../../../../services/ImportService';
import DownloadService from '../../../../services/DownloadService';
import {mapGetters, mapActions} from 'vuex';
import numberHelper from '../../../../helpers/numberHelper';
import objectHelper from '../../../../helpers/objectHelper';
import { dateHelper } from '../../../mixins/dateHelper';
import { helpers, required, numeric, decimal} from 'vuelidate/lib/validators';

export default {
    name: 'callforbids-createedit',
    components: {AuctionItemModal, FileUploadModal},
    mixins: [dateHelper],
    data() {
        return {
            editMode: false,
            excelFile: null,
            selectedOrganizer: null,
            doneLoading: false,
            userSearch: '',
            users: [],
            availableUsers:[],
            selectedUser: [],
            auctionItemToDelete: {},
            auction: {
                users: [],
                precision: 2,
                extend_after_bid: 0,
                start_date_time: "08:00",
                end_date_time: "20:00"
            },
            currentAuctionItem: {},
            relatedQuestionnaires: [],
            currentAuctionItemEditMode: false,
            currentFile: {
                name: '',
            },
            editingFile: false,
            isAuction: false,
            errorMessage: '',
            isClipboard: true,
            isCheck: false,
            usage_type: ''
        }
    },
    created() {
        this.isAuction = this.$route.path.indexOf('/app/auktionen') > -1;
        return this.fetchOrganizers()
            .then(() => {
                this.$store.commit('loading/setLoading', false);

                return this.fetchSelectionLists()
                .then(() => {
                    this.$store.commit('loading/setLoading', false);

                    if(this.$route.params.id) {
                        this.$store.commit('loading/setLoading', true);
                        callForBidsService.fetch(this.$route.params.id)
                            .then(data => {
                                if (data.data.success === false)
                                {
                                    this.$notify({
                                        group: 'global',
                                        title: this.$t("cfbcreate.load_error_title"),
                                        type: 'error',
                                        text: data.data.message
                                    });
                                } else {
                                    this.setAuction(data.data);
                                    this.editMode = true;
                                    this.doneLoading = true;
                                    this.selectedOrganizer = this.auction.organizer ? this.auction.organizer.id : null;
                                    this.$store.commit('loading/setLoading', false);

                                    return this.fetchAssignedUsers()
                                        .then(() => {
                                            return questionnaireService.fetchForAuctions(this.auction.id)
                                                .then(response => {
                                                    this.relatedQuestionnaires = response.data;
                                                });
                                        });
                                    }
                            });

                    }else {
                        this.doneLoading = true;

                    }
                });
            });
    },
    validations() {
        let validations = {
            auction: {
                title_de: {
                    required
                },
                title_en: {
                    required
                },
                start_date: {
                    required
                },
                end_date: {
                    required
                },
                contact: {
                    required
                }
            },
            selectedOrganizer: {
                required
            },
            excelFile: {
                required
            }
        };

        if(this.isAuction) {
            validations['auction']['extend_after_bid'] = { required }
        }

        return validations;
    },
    methods: {
        ...mapActions({
            fetchOrganizers: 'callForBids/fetchOrganizers',
            fetchSelectionLists: 'callForBids/fetchSelectionLists'
        }),
        setAuction(auction) {
            auction.start_date = this.$moment(auction.start_date);
            auction.start_date_date = auction.start_date.clone().startOf('day').toDate();
            auction.start_date_time = auction.start_date.format('HH:mm');
            auction.end_date = this.$moment(auction.end_date);
            auction.end_date_date = auction.end_date.clone().startOf('day').toDate();
            auction.end_date_time = auction.end_date.format('HH:mm');
            this.auction = auction;
        },
        async onSubmit() {
            this.auction.start_date = this.dateTimeCombine(this.auction.start_date_date, this.auction.start_date_time);
            this.auction.end_date = this.dateTimeCombine(this.auction.end_date_date, this.auction.end_date_time);

            // TODO fix errors not resetting
            this.$v.auction.start_date.$touch();
            this.$v.auction.end_date.$touch();
            this.$v.$touch();
            if(this.$v.auction.$error) {
                return;
            }

            if(!this.editMode) {
                this.create();
            }else {
                this.update();
            }
        },
        create() {
            this.isAuction = this.$route.path.indexOf('/app/auktionen') > -1;
            this.auction.organizer = this.selectedOrganizer;

            this.$store.commit('loading/setLoading', true);
            if(this.isAuction) {
                this.auction.bids_active = true;
            }
            callForBidsService.create(this.auction)
                .then(response => {
                    this.$store.commit('loading/setLoading', false);

                    if(response.status === undefined || response.data.success === true) {
                        this.setAuction(response.data);
                        this.editMode = true;

                        this.$notify({
                            group: 'global',
                            title: this.editType + this.$t("cfbcreate.notify_success_title"),
                            type: 'success',
                            text: this.$t("cfbcreate.notify_success_message1") + this.editType + this.$t("cfbcreate.notify_success_message2")
                        });

                        questionnaireService.fetchForAuctions(this.auction.id)
                        .then(response => {
                            this.relatedQuestionnaires = response.data;
                        });

                    }else {
                        this.$notify({
                        group: 'global',
                        title: this.$t("cfbcreate.notify_error_title") + this.editType,
                        type: 'error',
                        text: response.data.message
                    });
                    }
                })
                .catch(error => {
                    this.$store.commit('loading/setLoading', false);

                    this.$notify({
                        group: 'global',
                        title: this.$t("cfbcreate.notify_error_title") + this.editType,
                        type: 'error',
                        text: error.message
                    });
                });
        },
        update() {
            this.auction.organizer = this.selectedOrganizer
            this.auction.relatedQuestionnaires = this.relatedQuestionnaires;

            this.$store.commit('loading/setLoading', true);

            callForBidsService.update(this.auction.id, this.auction)
                .then(response => {
                    this.$store.commit('loading/setLoading', false);

                    if((response.success === undefined) && ((response.data.success === undefined) || (response.data.success === true))) {
                        this.setAuction(response.data);
                        this.editMode = true;

                        this.$notify({
                            group: 'global',
                            title: this.editType + this.$t("cfbcreate.notify_correction_title"),
                            type: 'success',
                            text: this.$t("cfbcreate.notify_correction_message1") + this.editType +this.$t("cfbcreate.notify_correction_message2")
                        });

                    } else {
                        this.$notify({
                            group: 'global',
                            title: this.$t("cfbcreate.notify_correction_error") + this.editType,
                            type: 'error',
                            text: (response.data === undefined) ? response.message : response.data.message,
                        });
                    }
                })
                .catch(error => {
                    this.$store.commit('loading/setLoading', false);

                    this.$notify({
                        group: 'global',
                        title: this.$t("cfbcreate.notify_correction_error") + this.editType,
                        type: 'error',
                        text: error.message
                    });
                });
        },
        copyText(text) {
            navigator.clipboard.writeText(text);
            this.$notify({
                group: 'global',
                title: 'In die Zwischenablage kopiert',
                type: 'success',
                text: this.text,
                autoHideDelay: 1500
            });
        },
        reloadAuctionItemList() {
            this.$store.commit('loading/setLoading', true);
            callForBidsService.listAuctionItems(this.auction.id)
                .then(response => {
                    this.$store.commit('loading/setLoading', false);
                    this.auction.items = response.data;
                })
        },
        reloadFiles() {
            this.$store.commit('loading/setLoading', true);
            callForBidsService.listFiles(this.auction.id)
                .then(response => {
                    this.auction.files = response.data;
                    this.$store.commit('loading/setLoading', false);
                });
        },
        showNewItemForm() {
            this.currentAuctionItemEditMode = false;
            this.$refs.auctionItemModal.setAuctionItem({});
            this.$refs.auctionItemModal.showModal();
        },
        findItemByOrder(order) {
            for(var i=0; i< this.auction.items.length; i++) {
                if(this.auction.items[i].order == order) {
                    return this.auction.items[i];
                }
            }
        },
        moveItemUp(order) {
            var itemToMoveUp = this.findItemByOrder(order);
            var itemToMoveDown = this.findItemByOrder(order-1);

            itemToMoveUp.order = order-1;
            itemToMoveDown.order = order
        },
        moveItemDown(order) {
            var itemToMoveDown = this.findItemByOrder(order);
            var itemToMoveUp = this.findItemByOrder(order+1);

            itemToMoveDown.order = order+1;
            itemToMoveUp.order = order;
        },
        showFileForm() {
            this.$refs.fileUploadModal.showModal();
        },   
        editAuctionItem(item) {
            var copiedItem = objectHelper.copy(item);
            copiedItem.actual_value = copiedItem.actual_value ? numberHelper.toCurrency(copiedItem.actual_value, this.auction.precision) : undefined;
            copiedItem.price_alert_value_buyer = copiedItem.price_alert_value_buyer ? numberHelper.toCurrency(copiedItem.price_alert_value_buyer, this.auction.precision) : undefined;
            copiedItem.price_alert_value_supplier = copiedItem.price_alert_value_supplier ? numberHelper.toCurrency(copiedItem.price_alert_value_supplier, this.auction.precision) : undefined;
            copiedItem.lowest_bid = copiedItem.lowest_bid ? numberHelper.toCurrency(copiedItem.lowest_bid, this.auction.precision) : undefined;

            this.$refs.auctionItemModal.setAuctionItem(copiedItem);
            this.$refs.auctionItemModal.showModal();
            this.$refs.auctionItemModal.enterEditMode();
        },
        deleteFile(item) {
            this.$store.commit('loading/setLoading', true);
            callForBidsService.deleteFile(item.id)
                .then(callForBidsService.listFiles(this.auction.id)
                        .then(response => {
                            this.auction.files = response.data;
                            this.$store.commit('loading/setLoading', false);
                        }))
                .catch(error => {
                    this.$store.commit('loading/setLoading', false);
                    this.$notify({
                        group: 'global',
                        title: this.$t("cfbcreate.notify_deletefile_title"),
                        type: 'error',
                        text: error.message
                    });
                });

        },
        downloadFile(item) {
            this.$store.commit('loading/setLoading', true);
            callForBidsService.downloadFile(item)
                .then(response => {
                    this.$store.commit('loading/setLoading', false);
                    const url = window.URL.createObjectURL(new Blob([response], {type: item.mimetype}));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', item.filename);
                    document.body.appendChild(link);
                    link.click();
                    link.parentElement.removeChild(link);
                });
        },
        editFile(item) {
            this.$refs.fileUploadModal.showModal();
            this.$refs.fileUploadModal.setFileItem(JSON.parse(JSON.stringify(item)));
            this.$refs.fileUploadModal.enterEditMode();
        },
        searchUser(query) {
            callForBidsService.searchUser(query)
                .then(response => {
                    this.availableUsers = response.data;
                });
        },
        addUserToAuction() {
            if(this.selectedUser) {
                this.$store.commit('loading/setLoading', true);

                callForBidsService.addUser(this.auction.id, this.selectedUser)
                    .then(response => {
                        this.selectedUser = null;
                        this.$store.commit('loading/setLoading', false);
                        if(!response.data.success) {

                            this.$notify({
                                group: 'global',
                                title: this.$t("cfbcreate.notify_addusererror_title"),
                                type: 'error',
                                text: response.data.message
                            });

                            return;
                        }
                        this.fetchAssignedUsers();
                        this.userSearch = '';
                        this.selectedUser = null;
                    })
                    .catch(error => {
                        this.$store.commit('loading/setLoading', false);
                        this.$notify({
                            group: 'global',
                            title: this.$t("cfbcreate.notify_addusererror_title"),
                            type: 'error',
                            text: error.message
                        });
                    });
            }
        },
        fetchAssignedUsers() {
            return callForBidsService.getAssignedUsers(this.auction.id)
                .then(response => {
                    this.users = response.data;
                });
        },
        unassignUser(user) {
            this.$store.commit('loading/setLoading', true);
            return callForBidsService.unassignUser(this.auction.id, user)
                .then(response => {
                    this.$store.commit('loading/setLoading', false);
                    return this.fetchAssignedUsers();
                });
        },
        showImport() {
            this.excelFile = null;
            //this.$refs.excelFileInput.reset();
            this.$refs.importModal.show();
        },
        importExcelFile() {
            this.$v.excelFile.$touch();
            if (this.$v.excelFile.$error) {
                this.$notify({
                            group: 'global',
                            title: 'Import',
                            type: 'error',
                            text: 'Datei auswählen.',
                        });
                return;
            }

            importService.importAuctionItem(this.excelFile, this.auction.id)
                .then(response => {
                    if(response.data.success) {
                        this.$refs.excelFileInput.reset();
                        this.$refs.importModal.hide();
                        this.$notify({
                            group: 'global',
                            title: this.$t("cfbcreate.notify_itemimportsuccess_title"),
                            type: 'success',
                            text: this.$t("cfbcreate.notify_itemimportsuccess_message")
                        });

                        this.$store.commit('loading/setLoading', true);
                        return callForBidsService.listAuctionItems(this.auction.id)
                            .then(response => {
                                this.$store.commit('loading/setLoading', false);
                                this.auction.items = response.data;
                            })
                    } else {
                        this.errorMessage = response.data.message;
                        this.$refs.importErrorModal.show();
                        this.$refs.importModal.hide();
                    }
                })
                .catch(error => {
                    this.errorMessage = error.message;
                    this.$refs.importErrorModal.show();
                });
        },
        toCurrency(value) {
            return numberHelper.toCurrency(value, this.auction.precision);
        },
        requestDeleteAuctionItem(item) {
            this.auctionItemToDelete = item;
            this.$refs.confirmationModal.show();
        },
        deleteAuctionItem() {
            this.$store.commit('loading/setLoading', true);
            callForBidsService.deleteAuctionItem(this.auctionItemToDelete.id)
                .then(response => {
                    this.$refs.confirmationModal.hide();
                    this.auctionItemToDelete = {};

                    if(response.data.success) {
                        this.$notify({
                            group: 'global',
                            title: this.$t("cfbcreate.notify_itemdeletesuccess_title"),
                            type: 'success',
                            text: this.$t("cfbcreate.notify_itemdeletesuccess_message")
                        });


                        callForBidsService.listAuctionItems(this.auction.id)
                            .then(response => {
                                this.$store.commit('loading/setLoading', false);
                                this.auction.items = response.data;
                            });

                    }else {
                        this.$notify({
                            group: 'global',
                            title: this.$t("cfbcreate.notify_itemdeleteerror_title"),
                            type: 'error',
                            text: response.data.message
                        });
                        this.$store.commit('loading/setLoading', false);
                    }
                })
                .catch(error => {
                    this.$store.commit('loading/setLoading', false);
                    this.$notify({
                            group: 'global',
                            title: this.$t("cfbcreate.notify_itemdeleteerror_title"),
                            type: 'error',
                            text: this.$t("cfbcreate.notify_itemdeleteerror_message")
                        });
                    this.$refs.confirmationModal.hide();
                    this.auctionItemToDelete = {};
                });
        },
        moveFileUp(item) {
            this.$store.commit('loading/setLoading', true);
            callForBidsService.moveFileUp(item)
                .then(response => {

                    return callForBidsService.listFiles(this.auction.id)
                            .then(response => {
                                this.auction.files = response.data;
                                this.$store.commit('loading/setLoading', false);
                            });
                });
        },
        moveFileDown(item) {
            this.$store.commit('loading/setLoading', true);
            callForBidsService.moveFileDown(item)
                .then(response => {
                    return callForBidsService.listFiles(this.auction.id)
                            .then(response => {
                                this.auction.files = response.data;
                                this.$store.commit('loading/setLoading', false);
                            });
                });
        },
        downloadTemplate() {
            this.$store.commit('loading/setLoading', true);
            importService.downloadTemplate('Importvorlage_Positionen.xlsx')
                .then(response => {
                    this.$store.commit('loading/setLoading', false);
                    DownloadService.processDownload(response.data, 'Importvorlage_Positionen.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
                });
        }
    },
    computed: {
        ...mapGetters({
            organizers: 'callForBids/organizers',
            users: 'contracts/users',
            hasRole: 'auth/hasRole',
            usageTypes: 'callForBids/usageTypes',
            questionnaires: 'questionnaires/questionnaires'
        }),
        editType() {
            return this.isAuction ? this.$t("cfbcreate.auction") : this.$t("cfbcreate.tender");
        },
        itemTableFields() {
            return [
                {   key: 'id',                  label: 'Id'                                                     },
                {   key: 'order',               label: this.$t(`cfbcreate.label_item`)                          },
                {   key: 'name',                label: this.$t(`cfbcreate.label_name`)                          },
                {   key: 'description',         label: this.$t(`cfbcreate.label_spec`)                          },
                {   key: 'amount',              label: this.$t(`cfbcreate.label_amount`), formatter: value => { return numberHelper.toFormattedStringWithThousands(value); }          },
                {   key: 'unit',                label: this.$t(`cfbcreate.label_unit`)                          },
                {   key: 'price_unit',          label: this.$t(`cfbcreate.label_priceunit`)                     },
                {   key: 'lowest_bid',          label: this.$t(`cfbcreate.label_lowestbid`)                     },
                {   key: 'quantity_factor',     label: this.$t(`cfbcreate.label_quantityfactor`), formatter: value => { return numberHelper.toFormattedStringWithThousands(value); }          },
                {   key: 'period_of_demand',    label: this.$t(`cfbcreate.label_periodofdemand`)                },
                {   key: 'commodity_group',     label: this.$t(`cfbcreate.label_commoditygroup`)                },
                {   key: 'actual_value',        label: this.$t(`cfbcreate.label_actualvalue`)                   },
                {   key: 'price_alert_value_buyer',     label: this.$t(`cfbcreate.label_price_alert_value_buyer`)                   },
                {   key: 'price_alert_value_supplier',  label: this.$t(`cfbcreate.label_price_alert_value_supplier`)                },
                {   key: 'actions',             label: this.$t(`cfbcreate.label_actions`)                       },
            ];
        },
        fileTableFields() {
            return [
                {   key: 'name',                label: this.$t(`cfbcreate.label_filename`)            },
                {   key: 'description',         label: this.$t(`cfbcreate.label_filedescription`)     },
                {   key: 'filename',            label: this.$t(`cfbcreate.label_file`)                },
                {   key: 'size',                label: this.$t(`cfbcreate.label_filesize`)            },
                {   key: 'mimetype',            label: this.$t(`cfbcreate.label_filetype`)            },
                {   key: 'actions',             label: this.$t(`cfbcreate.label_actions`)             }
            ];
        },
        userTableFields() {
            return [
                {   key: 'name',                                label: this.$t(`cfbcreate.label_username`),     sortable: true  },
                {   key: 'company',                             label: this.$t(`cfbcreate.label_company`),      sortable: true  },
                {   key: 'role.name',                           label: this.$t(`cfbcreate.label_role`),         sortable: true  },
                {   key: 'lksg_scope',                          label: this.$t(`user.lksg_scope`),              sortable: true  },
                {   key: 'accepted_terms_of_service',           label: this.$t(`cfbcreate.label_tos_accepted`), sortable: true  },
                {   key: 'proof_of_entrepreneurial_status',     label: this.$t(`cfbcreate.label_entrepreneurial_status`), sortable: true  },
                {   key: 'actions',                             label: this.$t(`cfbcreate.label_actions`)                       }

            ];
        },
    },
    watch: {
        userSearch: _.debounce(function(query) {
            if(query && query.length > 1)
                this.searchUser(query)
        } , 200),
        '$route': function() {
            this.isAuction = this.$route.path.indexOf('/app/auktionen') > -1;
        }
    }
};
</script>
